import type { JsonLD } from "nuxt-jsonld/dist/types/index.d";
import { useDYAppConfig } from "~/modules/nuxt3-module-doyac/composables/config";
import { $dy__fetch } from "./fetch";

export function useDYStructuredDataApi() {
  const { API_BASE_URL } = useDYAppConfig()

  const get = async (typedPk: string, expiryDays?:number, makeOnly?:boolean): Promise<JsonLD | null> => {
    if (typedPk && typedPk.includes('-{}-')) {
      console.error('!!!!!!!! [CORRUPTED_TYPED_PK_DETECTED] !!!!!!!!');
      console.error('Value:', typedPk);
      console.trace('Stack Trace:');
    }
    // console.log('useDYStructuredDataApi::get::start', typedPk, expiryDays, makeOnly)
    const _params: any = { expiryDays, makeOnly }
    if (!makeOnly && !typedPk.includes('board')) {  ///게시판인 경우라면 하루에도 몇번을 수정하던 계속 변경된 걸로 다시 만들어야하므로.
      _params.edgeCache = '6h'
    }
    // console.log('useDYStructuredDataApi::get::params', typedPk, expiryDays, makeOnly)

    if (makeOnly) {
      // console.log('useDYStructuredDataApi::get::makeOnly::start', typedPk, expiryDays, makeOnly)
      // makeOnly일 때는 응답이 중요하지 않으므로 0.2초 타임아웃을 걸고 비동기로 던집니다.
      // SSR Hanging 방지를 위해 컨텍스트 의존성이 없는 $fetch를 직접 사용합니다.
      $fetch<JsonLD>(`${API_BASE_URL}/api/structured-data/${typedPk}`, { 
        method: 'get', 
        params: _params,
        timeout: 200 
      }).catch(() => { return null; /* 타임아웃 등 에러 무시 */ })
      // console.log('useDYStructuredDataApi::get::makeOnly::end', typedPk, expiryDays, makeOnly)
      return null
    }else{
      // console.log('useDYStructuredDataApi::get::not makeOnly::start', typedPk, expiryDays, makeOnly)
      try {
        let timeout: number;
        if(typedPk.includes('board')){
          // ⚠️ 이 300ms는 의도된 값이다. 절대 늘리지 말 것.
          //
          // 게시판은 파일이 없을 때 백엔드에 '생성만 시켜놓고' 짧게 끊는 설계다.
          // 최초 1회는 구조화 데이터를 못 실어보낼 수 있으나, 그 다음 요청부터는
          // 이미 만들어진 json을 디스크에서 즉시 읽으므로(readJsonAndMakeFile) 문제가 없다.
          // 이 값을 늘리면 봇 요청마다 SSR이 백엔드 생성이 끝날 때까지 붙잡혀 있게 된다.
          //
          // 실제로 저지른 실수(2026-07-14): board_blog의 FAQPage/HowTo가 SEO에 안 나가는 원인을
          // 이 타임아웃이라고 오진해 3000ms로 늘렸었다. 진짜 원인은 전혀 달랐다 —
          // 페이지에서 useJsonld를 중첩 async 함수 안에서 호출해 head 등록이 조용히 유실된 것이었다.
          // (수정: modules/nuxt3-module-user-ingang/pages/board/[boardName]/[no].vue)
          // 구조화 데이터가 안 보인다면 이 값이 아니라 useJsonld 호출 위치부터 의심할 것.
          timeout = 300;
        }else{
          timeout = 4000
        }
        const data = await $fetch<JsonLD>(`${API_BASE_URL}/api/structured-data/${typedPk}`, { 
          method: 'get', 
          params: _params,
          headers: { 'Accept': 'application/json' },
          timeout: timeout
        })
        // console.log('useDYStructuredDataApi::get::not makeOnly::end', typedPk, expiryDays, makeOnly)
        return data
      } catch (e) {
        console.error('useDYStructuredDataApi::get::not makeOnly::error', typedPk, e)
        return null
      }
    }
  }

  return {
    get
  }
}